// extracted by mini-css-extract-plugin
export default {"empty-message":"NJjnb4Pb9tmAYtfdlnJdPg==","image-container":"_4GnJac4FSvKNB1gRyxRTCQ==","no-notification":"t2SMxpPk1ONZaQq1dB5SfQ==","description":"YFV2QpT3Z4RJXp3yAjOYUg=="};